(() => {
    const selectors = {
        manageCookieButton: ".js-manage-cookie-button",
        cookieBar: "#tinycookie-wrapper.bar-inline",
        footerAddToCart: ".js-footer-add-to-cart",
        productFormSubmitButton: ".js-main-product-section product-form [type='submit']"
    };

    document.addEventListener("click", (event) => {
        const manageCookieButton = event.target.closest(selectors.manageCookieButton);
        const footerAddToCart = event.target.closest(selectors.footerAddToCart);

        if (manageCookieButton) {
            let cookieBar = document.querySelector(selectors.cookieBar);

            if (!cookieBar && window.Shopify.tinycookie) {
                window.Shopify.tinycookie.loadCookieBar();
                cookieBar = document.querySelector(selectors.cookieBar);
            }

            if (cookieBar) {
                cookieBar.style.display = "block";
            }
        }

        if (footerAddToCart) {
            event.preventDefault();

            const productFormSubmitButton = document.querySelector(selectors.productFormSubmitButton);

            if (!productFormSubmitButton) return;

            const scrollY = window.scrollY;
            const cartDrawer = document.querySelector('cart-drawer');
            productFormSubmitButton.click();
            if (cartDrawer) cartDrawer._scrollY = scrollY;
            window.scrollTo(0, scrollY);
        }
    })

    if (!customElements.get('footer-accordion')) {
        class FooterAccordion extends HTMLElement {
            static selectors = {
                control: '.js-footer-accordion-control',
                content: '.js-footer-accordion-content',
                contentInner: '.js-footer-accordion-content-inner'
            };

            static classes = {
                isOpen: 'is-open'
            };

            connectedCallback() {
                this.timeout;
                this.control = this.querySelector(FooterAccordion.selectors.control);
                this.content = this.querySelector(FooterAccordion.selectors.content);
                this.contentInner = this.querySelector(FooterAccordion.selectors.contentInner);

                if (!this.control || !this.content || !this.contentInner) return;

                this.control.addEventListener('click', () => this.handleToggleClick());
            }

            disconnectedCallback() {
                clearTimeout(this.timeout);
            }

            handleToggleClick() {
                const isOpen = this.classList.contains(FooterAccordion.classes.isOpen);

                isOpen ? this.close() : this.open();
            }

            open() {
                clearTimeout(this.timeout);
                this.classList.add(FooterAccordion.classes.isOpen);
                this.content.style.height = `${this.contentInner.offsetHeight}px`;

                this.timeout = setTimeout(() => {
                    this.content.style.height = 'auto';
                }, 400);
            }

            close() {
                clearTimeout(this.timeout);
                this.classList.remove(FooterAccordion.classes.isOpen);
                this.content.style.height = `${this.contentInner.offsetHeight}px`;

                this.timeout = setTimeout(() => {
                    this.content.style.height = '0';
                }, 0);
            }
        }

        customElements.define('footer-accordion', FooterAccordion);
    }
})();
